import React from 'react'
import './index.css'
import { withTranslation } from 'react-i18next'
import CustomCard from 'components/CustomCard'
import InfoWithTooltip from 'components/InfoWithCustomTooltip'
import {
  Link,
  PeopleAltOutlined,
  Visibility,
  PlaylistAddCheck
} from '@material-ui/icons'
import EmptyState from '../EmptyState'
import LinkTable from './components/LinkTable'
import { CARD_CONFIGS, DEFAULT_VALUES, getConversionMetrics } from './constants'

const ICON_COMPONENTS = {
  PeopleAltOutlined,
  Link,
  Visibility,
  PlaylistAddCheck
}

const ConversionLink = ({ linkData = DEFAULT_VALUES, loadingLinkData, t }) => {
  const metrics = getConversionMetrics(linkData)
  const shouldShowEmptyState =
    !loadingLinkData && !linkData?.Answered && !linkData?.Opened

  if (shouldShowEmptyState) {
    return (
      <EmptyState description={t('conversion-report.empty.descriptionLink')} />
    )
  }

  const cardsConfig = [
    {
      key: 'total-people',
      title: t('conversion-report.link.total-person'),
      subValue: `${linkData.TotalIdentified} pessoas identificadas / ${linkData.TotalAnonymousNotAnswered} anônimas`,
      value: metrics.totalPeople,
      config: CARD_CONFIGS.TOTAL_PEOPLE,
      footerText: t('conversion-report.link.total-personInfo')
    },
    {
      key: 'generated-links',
      title: t('conversion-report.link.generated-link'),
      value: linkData.TotalDirectLinkGenerated,
      config: CARD_CONFIGS.GENERATED_LINKS,
      footerText: t('conversion-report.link.generated-linksInfo')
    },
    {
      key: 'opening',
      title: t('conversion-report.link.opening'),
      subValue: `${metrics.viewsPerPerson} visualizações por pessoa`,
      value: linkData.Opened,
      config: CARD_CONFIGS.OPENING,
      footerText: t('conversion-report.link.openingInfo')
    },
    {
      key: 'answered',
      title: t('conversion-report.link.answered'),
      subValue: `${metrics.answeredPercentage} do total de pessoas que clicaram`,
      value: linkData.Answered,
      config: CARD_CONFIGS.ANSWERED,
      footerText: t('conversion-report.link.answeredInfo')
    }
  ]

  return !loadingLinkData && !linkData.Answered && !linkData.Opened ? (
    <EmptyState description={t('conversion-report.empty.descriptionLink')} />
  ) : (
    <div className="conversion-link-wrapper">
      <div className="conversion-link-cards">
        {cardsConfig.map((card) => (
          <CustomCard
            key={card.key}
            loading={loadingLinkData}
            titleText={card.title}
            subValue={<span>{card.subValue}</span>}
            titleIconComponent={React.createElement(
              ICON_COMPONENTS[card.config.icon],
              { color: card.config.color }
            )}
            value={card.value}
            footerInfo={
              <InfoWithTooltip
                text={card.footerText}
                tooltipContent={{
                  title: card.config.tooltipTitle,
                  subtitle: card.config.subText
                }}
              />
            }
          />
        ))}
      </div>

      <div>
        <LinkTable />
      </div>
    </div>
  )
}

export default withTranslation()(ConversionLink)
